var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumidityMid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_156_27285",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_156_27285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0003 30.4581C13.86 30.4581 11.1861 29.372 8.97845 27.1998C6.77081 25.0276 5.66699 22.3831 5.66699 19.2665C5.66699 17.779 5.95623 16.3564 6.5347 14.9988C7.11317 13.6411 7.93366 12.4429 8.99616 11.404L15.017 5.48939C15.3003 5.22967 15.6132 5.02897 15.9555 4.8873C16.2979 4.74564 16.6462 4.6748 17.0003 4.6748C17.3545 4.6748 17.7028 4.74564 18.0451 4.8873C18.3875 5.02897 18.7003 5.22967 18.9837 5.48939L25.0045 11.404C26.067 12.4429 26.8875 13.6411 27.466 14.9988C28.0444 16.3564 28.3337 17.779 28.3337 19.2665C28.3337 22.3831 27.2298 25.0276 25.0222 27.1998C22.8146 29.372 20.1406 30.4581 17.0003 30.4581ZM8.50033 19.2665H25.5003C25.5003 18.1567 25.2878 17.1002 24.8628 16.0967C24.4378 15.0932 23.8239 14.2137 23.0212 13.4581L17.0003 7.50814L10.9795 13.4581C10.1767 14.2137 9.56283 15.0932 9.13783 16.0967C8.71283 17.1002 8.50033 18.1567 8.50033 19.2665Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidityMid);
export default __webpack_public_path__ + "static/media/humidity_mid.fab56dba2b1ae177f20361439675d42b.svg";
export { ForwardRef as ReactComponent };